import { getCurrentScope } from './lib';

export const setSentryTag = (key: string, value?: string): void => {
  if (getCurrentScope !== undefined) {
    getCurrentScope().setTag(key, value);
  }
};
